import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-info-sms',
  templateUrl: './info-sms.component.html',
  styleUrls: ['./info-sms.component.scss']
})
export class InfoSmsComponent implements OnInit {

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, { static: true })
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>


  constructor(@Inject(MAT_DIALOG_DATA) private datos) { 
    this.tableOpt = datos.sms;
    this.dtOptions = {
      scrollX: true,
      scrollY: '383px',
      lengthMenu: true,
      lengthChange: true,
      pageLength: 10,
      scrollCollapse: true,
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        }
      },
      columns: [
        {
          title:'ID sms',
          data: 'ID_bitacora'
        },
        {
          title:'Tipo SMS',
          data: 'TipoSMS'
        },
        {
          title:'Mensaje',
          data: 'mensaje'
        },  
        {
          title:'Celular',
          data: 'Celular'
        },
        {
          title:'Nombre Beneficiario',
          data: 'beneficiario'
        },
        {
          title:'Documento beneficiario',
          data: 'documento_beneficiario'
        },
        {
          title:'Documento titular',
          data: 'documento_titular'
        }, 
        {
          title:'Nombre titular',
          data: 'Nombre_titular'
        }, 
        {
          title:'Nit grupo',
          data: 'Nit_grupo'
        }, 
        {
          title:'Nombre grupo',
          data: 'Nombre_grupo'
        },
        {
          title:'Fecha envio',
          data: 'Fecha_envio'
        },
        {
          title:'Usuario que envia SMS',
          data: 'Nombre_usuario'
        },
        {
          title:'Area',
          data: 'Area'
        },
        {
          title:'Dependencia',
          data: 'Dependencia'
        },
       ]
    };
  }

  ngOnInit() {
  }

}
